import {
  apiGET
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/notifications.ts
var locale = process.env.GATSBY_INTL_LOCALE;
var languages = {
  en: "en",
  in: "en",
  ca: "en-ca",
  pe: "es-pe",
  cl: "es-cl",
  pt: "pt-br"
};
var language = languages[locale] || "en";
var getNotificationsBage = async () => {
  return await apiGET("/notifications/badge");
};
var getNotificationsList = async ({
  expired = false,
  pageSize = 10,
  pageNumber = 0
}) => {
  const status = expired ? "expired" : "active/?sort=clickedOn,desc&sort=endDate,asc";
  return await apiGET(`/notifications/${status}`, {
    params: {
      pageSize,
      pageNumber,
      language
    }
  });
};
var getNotificationRedirect = async ({
  playerNotificationId,
  startDate
}) => {
  return await apiGET(
    `/notifications/${playerNotificationId}/${startDate}/redirect-url`,
    { params: { language } }
  );
};

export {
  getNotificationsBage,
  getNotificationsList,
  getNotificationRedirect
};
